import { useStore } from 'hooks/useStore';
import { AutoComplete } from 'primereact/autocomplete';
import { useEffect, useRef, useState } from 'react';

export const useDrugSearchBar = () => {
  const {
    BDPortalStore: {
      isAllDrugsLoading,
      drugSearchInput,
      filteredDrugMoleculesForSearch,
      allDrugMoleculesDetailsForSearch,
      handleFilterDrugSearch,
      handleFetchAllConceptDetailsForSearch,
      handleDrugSearchInputChange,
    },
  } = useStore();
  const isSearchButtonDisabled = () => {
    return drugSearchInput ? false : true;
  };
  const serchfieldRef = useRef<AutoComplete>(null);
  const [isParallelIterationsModalVisibile, setIsParallelIterationsModalVisibile] = useState(false);
  const [selectedConceptName, setSelectedConceptName] = useState<string | null>(null);

  useEffect(() => {
    serchfieldRef.current?.focus();
    handleFetchAllConceptDetailsForSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleEnterKeyDownDrugSearchField = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      console.log(drugSearchInput);
      handleSearch(drugSearchInput, true);
    }
  };

  const handleSearch = (input: string, fromEnterKeyword: boolean = false) => {
    if (!fromEnterKeyword) {
      handleDrugSearchInputChange(input);
    }
    const selectedDrug = allDrugMoleculesDetailsForSearch.filter(
      item => item.MoleculeAndForm.toLowerCase() === input.toLowerCase()
    );

    if (selectedDrug.length === 1) {
      setIsParallelIterationsModalVisibile(true);
      setSelectedConceptName(selectedDrug[0].MoleculeAndForm);
    }
  };

  const toggleIterationModalVisibility = () => {
    if (isParallelIterationsModalVisibile) {
      setSelectedConceptName(null);
    }
    setIsParallelIterationsModalVisibile(!isParallelIterationsModalVisibile);
  };

  return {
    drugSearchInput,
    serchfieldRef,
    isAllDrugsLoading,
    filteredDrugMoleculesForSearch,
    handleFilterDrugSearch,
    isSearchButtonDisabled,
    handleDrugSearchInputChange,
    handleSearch,
    handleEnterKeyDownDrugSearchField,
    isParallelIterationsModalVisibile,
    toggleIterationModalVisibility,
    selectedConceptName,
  };
};
